module.exports = __webpack_public_path__ + "img/Bodice-Back-Ja-Kc-Lc.9d4aa881.png";